<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Notification Mail Create",
      items: [
        {
          text: "Notification Mail",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
      form: {
          email: "",
          type: "",
          is_disabled: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        email: {
        required,
      },
        type: {
        required,
      },
        is_disabled: {
            required,
        },
    },
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/notification-mail-create", {
            email:this.form.email,
            type: this.form.type,
            is_disabled: this.form.is_disabled,
            created_by: localStorage.getItem("uuid"),
            updated_by: localStorage.getItem("uuid"),
            accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.notificationmailform.reset();
            this.$swal("Good job!", "Notification Mail Added", "success");
            this.$router.push({ name: "notification_mail_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="notificationmailform" @submit.prevent="formSubmit">
              <div class="row">
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="email">Email</label>
                          <input
                              id="email"
                              v-model="form.email"
                              name="email"
                              type="email"
                              class="form-control"
                              placeholder="Type email"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.email.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.email.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label for="type">Type</label>
                          <select
                              id="type"
                              name="type"
                              v-model="form.type"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && $v.form.type.$error }">
                              <option value="" disabled style="display:none" selected>Select Type</option>
                              <option value='any'>Any</option>
                              <option value='flight'>Flight</option>
                              <option value='hotel'>Hotel</option>
                              <option value='flight+hotel'>Flight + Hotel</option>
                          </select>
                          <div
                              v-if="submitted && $v.form.type.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.type.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="is_disabled">Is Disabled</label>
                    <select
                      id="is_disabled"
                      name="is_disabled"
                      v-model="form.is_disabled"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.form.is_disabled.$error }">
                        <option value="" disabled style="display:none" selected>Disable</option>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </select>
                    <div
                      v-if="submitted && $v.form.is_disabled.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.is_disabled.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
